import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('get', `/api/roundtables/${id}/publish`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/publishRoundtable.js